import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ContactInfo from './ContactInfo';
import { Helmet } from 'react-helmet-async';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function ContactForm() {
  const [content, setContent] = useState({});
  const [formData, setFormData] = useState({ name: '', email: '', mobil: '', message: '' });
  const [status, setStatus] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/api/content/kontakt`).then(res => {
      const organized = res.data.reduce((acc, item) => ({ ...acc, [item.element_id]: item }), {});
      setContent(organized);
    });
  }, []);
  
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('Sender...');
    axios.post(`${API_URL}/api/contact`, formData)
      .then(() => {
        setStatus('Meldingen din er sendt! En kopi er sendt til din e-post.');
        setFormData({ name: '', email: '', mobil: '', message: '' });
      })
      .catch(() => setStatus('Noe gikk galt. Prøv igjen senere.'));
  };

// --- ERSTATT MED DENNE KORREKTE KODEN ---
  return (
    // Ytre wrapper for å holde BEGGE seksjonene
    <div>
      <Helmet>
      <title>Kontakt Oss – Sunnfjord Naprapatsenter i Førde</title>
      <meta name="description" content="Kontakt Sunnfjord Naprapatsenter for timebestilling eller spørsmål. Du finner oss sentralt i Førde. Se kart og åpningstider." />
    </Helmet>
      {/* SEKSJON 1: To-kolonners layout for skjema og info */}
      <div className="contact-page-layout">
        <div className="form-container">
          <h1>{content.kontakt_tittel?.value || 'Kontakt Oss'}</h1>
          <p>Send oss en melding direkte via skjemaet, eller bruk kontaktinformasjonen til høyre.</p>
          <form onSubmit={handleSubmit} className="styled-form">
            <div className="form-group">
              <label htmlFor="name">Navn</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required/>
            </div>
            <div className="form-group">
              <label htmlFor="email">E-post</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required/>
            </div>
            <div className="form-group">
              <label htmlFor="mobil">Mobil</label>
              <input type="tel" id="mobil" name="mobil" value={formData.mobil} onChange={handleChange} required pattern="[0-9]{8}" maxLength="8" title="Vennligst skriv inn et gyldig 8-sifret telefonnummer."/>
            </div>
            <div className="form-group">
              <label htmlFor="message">Melding</label>
              <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows="6" required></textarea>
            </div>
            <button type="submit" className="button">Send melding</button>
          </form>
          {status && <p className="form-status">{status}</p>}
        </div>
        <ContactInfo />
      </div>

      {/* SEKSJON 2: Kartet (nå UTENFOR og ETTER to-kolonners layouten) */}
      <section className="map-section">
        <h2>Her finner du oss</h2>
        <div className="map-container">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4874.453644438109!2d5.846000864671536!3d61.452309162465646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x461631627264be17%3A0x5a46dd64dd25c1d2!2sNaprapatsenteret-%20Naprapat%20Alexander%20Ask!5e0!3m2!1sno!2sno!4v1670193161238!5m2!1sno!2sno"
            width="100%" 
            height="450" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Kart over Sunnfjord Naprapatsenter">
          </iframe>
        </div>
      </section>
    </div>
  );
}

export default ContactForm;